// components/common/FilterSwitch.jsx
//
// A switch in the filter row, drawn as a filter box: the outline and the
// height of the dropdowns beside it. It is MUI's OutlinedInput with the switch
// in place of the text input, so the border, hover and focus colours come from
// the same rules as every other box. The box has no title: the switch's own
// text names it.
//
// `onChange` receives the new on/off value, not the event: the checkbox is
// controlled, so React puts it back to `checked` right after the click, and a
// caller that awaits a confirm before reading `event.target.checked` would
// read the old value.

import { forwardRef } from 'react';
import { FormControl, OutlinedInput, Switch } from '@mui/material';

// OutlinedInput renders this where its <input> would be and hands it the
// input's props, of which the switch takes three. The ref goes to the
// switch's own checkbox through its input slot, so a click on the box's
// padding focuses the switch the way it focuses a text box's text.
const SwitchInput = forwardRef(function SwitchInput({ className, checked, onChange, text }, ref) {
  return (
    <label className={`${className} filter-switch-input`}>
      <Switch size="small" checked={checked} onChange={onChange} slotProps={{ input: { ref } }} />
      <span>{text}</span>
    </label>
  );
});

export default function FilterSwitch({ label, checked, onChange }) {
  return (
    <FormControl size="small" className="filter-switch">
      <OutlinedInput
        inputComponent={SwitchInput}
        inputProps={{ checked, text: label }}
        onChange={(e) => onChange(e.target.checked)}
      />
    </FormControl>
  );
}
